import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { RbacActionEntity } from './rbac-action.entity';
import { RbacRoleEntity } from './rbac-role.entity';

@Index('_fk__rbac_action__id', ['fkRbacActionId'], {})
@Index('_fk__rbac_role__id', ['fkRbacRoleId'], {})
@Entity('_rbac_action__role')
export class RbacActionRoleEntity extends BaseEntity {
	@Column('int', {
		name: '_fk__rbac_action__id',
		nullable: true,
		unsigned: true,
	})
	public fkRbacActionId!: number | null;

	@Column('varchar', { name: '_action', nullable: true, length: 255 })
	public action!: string | null;

	@Column('int', { name: '_fk__rbac_role__id', unsigned: true })
	public fkRbacRoleId!: number;

	@ManyToOne(
		() => RbacActionEntity,
		(rbacAction) => rbacAction.rbacActionRoles,
		{
			onDelete: 'RESTRICT',
			onUpdate: 'RESTRICT',
		},
	)
	@JoinColumn([{ name: '_fk__rbac_action__id', referencedColumnName: 'id' }])
	public fkRbacAction!: RbacActionEntity;

	@ManyToOne(() => RbacRoleEntity, (rbacRole) => rbacRole.rbacActionRoles, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk__rbac_role__id', referencedColumnName: 'id' }])
	public fkRbacRole!: RbacRoleEntity;
}
